// react
import { useEffect, useState } from 'react';

// types
import { Pagination, Project } from '../../../../@types';

// router
import { useSearchParams } from 'react-router-dom';

// hooks
import { useFetch } from '../../../../hooks/useFetch';

// mui
import { Container } from '@mui/material';

// tables
import { TableProjects } from '../../../tables/cards/TableProjects/TableProjects';

// utils
import { defaultPagination } from '../../../../utils/defaults';

export const Table = () => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const [searchParams] = useSearchParams();

	// params
	const paramCountry = searchParams.get('country');
	const paramOrder = searchParams.get('order') || 'DESC';
	const paramOrderBy = searchParams.get('orderBy') || 'created';
	const paramPage = Number(searchParams.get('page') || 1);
	const paramQ = searchParams.get('q');

	// state
	const [pagination, setPagination] = useState<Pagination>({
		...defaultPagination,
		page: paramPage,
	});
	const [projects, setProjects] = useState<Project[]>([]);

	// fetch projects
	let urlProjects = `${process.env.REACT_APP_API_URL}/projects?fields=activities,country,idWbg,loans,name&page=${paramPage}&limit=${pagination.perPage}&populate=activities,activities.actor,country,loans&activityTypes=PROJECT_CREATED,PROJECT_UPDATED&orderBy=${paramOrderBy}&order=${paramOrder}`;

	if (paramCountry && paramCountry !== 'all') {
		urlProjects += `&country=${paramCountry}`;
	}

	if (paramQ) {
		urlProjects += `&q=${paramQ}`;
	}

	const { fetchRequest: fetchProjects, isLoading: isLoadingProjects } = useFetch({
		isLazy: true,
		url: urlProjects,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setProjects(res.data);
			}

			if (res.pagination) {
				setPagination(res.pagination);
			}
		},
	});

	// fetch projects when params change
	useEffect(() => {
		fetchProjects();
	}, [fetchProjects, paramCountry, paramOrder, paramOrderBy, paramPage, paramQ]);

	return (
		<section>
			<Container maxWidth={false}>
				<TableProjects isLoading={isLoadingProjects} pagination={pagination} projects={projects} />
			</Container>
		</section>
	);
};
